const canRetriggerStep = ({ data }: { data: unknown }): boolean => {
  if (
    typeof data === 'object'
    && !Array.isArray(data)
    && data !== null
  ) {
    if ('canRetrigger' in data) {
      return Boolean((data as unknown as { canRetrigger: boolean } | undefined)?.canRetrigger);
    }
  }
  return false;
};

export default canRetriggerStep;